import { useRef } from "react";
import { FaCamera } from "react-icons/fa";

import notify from "../../services/notify";
import { compressImage } from "../../services/imageCompression";

import styles from "./ImagePicker.module.css";

const ImagePicker = ({

    id,

    name,

    label = "انتخاب تصویر",

    value,

    preview,

    accept = "image/*",

    maxSize = 2 * 1024 * 1024,

    showPreview = true,

    canSelect = true,

    onBlocked,

    onChange,

}) => {

    const inputRef = useRef(null);

    const handleButtonClick = () => {

        if (!canSelect) {

            onBlocked?.();

            return;

        }

        inputRef.current?.click();

    };

    const handleSelectFile = async (e) => {

        const file = e.target.files?.[0];

        if (!file) return;

        if (!file.type.startsWith("image/")) {

            notify.warning(
                "فقط فایل تصویری مجاز است."
            );

            return;

        }

        const compressed =
            await compressImage(file);

        if (compressed.size > maxSize) {

            notify.warning(
                "حجم تصویر نباید بیشتر از ۲ مگابایت باشد."
            );

            return;

        }

        onChange(compressed);

        // اجازه انتخاب مجدد همان فایل
        e.target.value = "";

    };

    return (

        <div className={styles.wrapper}>

            {

                showPreview && (

                    <div className={styles.preview}>

                        {

                            value ? (

                                <img

                                    src={URL.createObjectURL(value)}

                                    alt="preview"

                                />

                            ) : preview ? (

                                <img

                                    src={preview}

                                    alt="preview"

                                />

                            ) : (

                                <div className={styles.placeholder}>

                                    <FaCamera />

                                </div>

                            )

                        }

                    </div>

                )

            }

            <input

                ref={inputRef}

                id={id}

                name={name}

                hidden

                type="file"

                accept={accept}

                onChange={handleSelectFile}

            />

            <button

                type="button"

                className={styles.button}

                onClick={handleButtonClick}

            >

                <FaCamera />

                <span>

                    {label}

                </span>

            </button>

        </div>

    );

};

export default ImagePicker;